import * as React from 'react';

import {getHumanReadableEntityTypeFromGraphQLEnum} from 'nutshell-core/utils';

import {LinkedEntity} from 'shells/linked-entity/linked-entity';
import {DisplayOnlyTable} from 'shells/table/display-only-table';

import type {BulkEditFragment} from 'nutshell-graphql-types';

import {EmptyState} from './empty-state';
import {getBulkEditStatusInfo} from './helpers';
import {useGetBulkEdits} from './hooks/use-get-bulk-edits';

export function BulkEditsTable() {
    const {bulkEdits, isLoading, error, hasNextPage, fetchMoreRows, isFirstLoad} =
        useGetBulkEdits();

    const columns = React.useMemo(
        () => [
            {
                id: 'startedTime',
                Header: 'Started time',
                accessor: (bulkEdit: BulkEditFragment) => bulkEdit.startedTime,
                dataType: 'timestamp',
                width: 200,
                hasLeftBorder: true,
            },
            {
                id: 'completedTime',
                Header: 'Completed time',
                accessor: (bulkEdit: BulkEditFragment) => bulkEdit.completedTime,
                dataType: 'timestamp',
                width: 200,
            },
            {
                id: 'entityType',
                Header: 'Type',
                accessor: (bulkEdit: BulkEditFragment) =>
                    bulkEdit.entityType
                        ? getHumanReadableEntityTypeFromGraphQLEnum(bulkEdit.entityType, true)
                        : 'Other',
                dataType: 'string',
                width: 150,
            },
            {
                id: 'user',
                Header: 'Initiated by',
                accessor: (bulkEdit: BulkEditFragment) => bulkEdit.user && bulkEdit.user,
                dataType: 'component',
                width: 150,
                Cell: ({cell}: any) => <LinkedEntity {...cell.value} type='users' />,
            },
            {
                id: 'status',
                Header: 'Status',
                accessor: (bulkEdit: BulkEditFragment) => getBulkEditStatusInfo(bulkEdit.status),
                dataType: 'statusBadge',
                hasRightBorder: true,
            },
        ],
        []
    );

    const specialStates = [
        {
            shouldRender: () => !error && !bulkEdits.length && !isLoading,
            component: <EmptyState noun='bulk edit' />,
        },
    ];

    return (
        <DisplayOnlyTable
            // @ts-expect-error
            columns={columns}
            data={bulkEdits}
            isLoading={isLoading}
            isFirstLoad={isFirstLoad}
            error={error}
            fullWidth={true}
            hasNextPage={hasNextPage}
            onFetchMoreRows={fetchMoreRows}
            specialStates={specialStates}
        />
    );
}
